//Read More
document.addEventListener("DOMContentLoaded", function() {
    let careerDescriptions = document.querySelectorAll('.careers-detail .career-description');
    if(careerDescriptions) {
        careerDescriptions.forEach(function(careerDescription) {
            let readMoreButton = careerDescription.querySelector('.read-more');
            if (readMoreButton) {
                readMoreButton.addEventListener('click', function(event) {
                    event.preventDefault();
                    careerDescription.classList.toggle('active');
                    if (careerDescription.classList.contains('active')) {
                        readMoreButton.textContent = 'Read Less';
                    } else {
                        readMoreButton.textContent = 'Read More';
                    }
                });
            }
        });
    }
});